import React from 'react';
import PlayerSambaVideos from 'components/PlayerSambaVideos';
import {
  Container,
  Alerts,
  ContainerBtn,
  ContainerImgInfo,
  ContentWrapper,
} from './style';
import Pill from 'assets/icon/icone-pilula.svg';
import Thermometer from 'assets/icon/icone-termometro.svg';
import TabelaNutricional from 'assets/images/tabela-nutricional.jpg';
import { useHistory } from 'react-router-dom';
import Product from 'services/product/models/product-interface';
import { SectionContainer } from 'components/Container';

type Props1 = {
  product: Product[] | any;
};

const Content: React.FC<Props1> = ({ product }) => {
  const history = useHistory();
  if (!product) {
    return null;
  }
  const {
    title,
    description,
    subtitle,
    video_reference,
    thumbnail,
    info,
    alerts,
  } = product;

  const handleClick = (): void => {
    history.push('/onde-comprar');
  };

  const handleExternalClick = (): void => {
    window.open(
      'https://www.drogaraia.com.br/regenesis-premium-120-capsulas.html',
      '_blank',
    );
  };

  return (
    <Container>
      <SectionContainer>
        <div className="title-wrapper">
          <h2>{title}</h2>
          <h3 className="subtitle">{subtitle}</h3>
        </div>
        <div className="video-wrapper">
          <div className="container-sambaVideos">
            <PlayerSambaVideos
              contentReference={video_reference}
              controlsToEnable={[
                'play',
                'pause',
                'quality',
                'fullscreen',
                'time',
                'volume',
                'speed',
                'subtitles',
                'settings',
              ]}
              getEventListeners={() => {}}
            />
          </div>
        </div>
      </SectionContainer>
      <div className="content-section">
        <SectionContainer>
          <ContentWrapper>
            <div className="thumb-wrapper">
              <img className="thumb-desktop" src={thumbnail} alt={thumbnail} />
            </div>
            <div className="info-wrapper">
              <div className="header-content-mobile">
                <img className="thumb" src={thumbnail} alt={thumbnail} />
                <h3>{subtitle}</h3>
              </div>
              <p>{description}</p>
              <Alerts>
                <div>
                  <div className="icon-title">
                    <img src={Pill} alt="recomendação de uso" />
                    <h4>Recomendações de uso</h4>
                  </div>
                  <p>{info.usage_recomendations}</p>
                </div>
                <div>
                  <div className="icon-title">
                    <img
                      className="temperature"
                      src={Thermometer}
                      alt="cuidados de conservação"
                    />
                    <h4>Cuidados de conservação</h4>
                  </div>
                  <p>{info.conservation_care}</p>
                </div>
                <div>
                  <p className="alert-medication">{alerts}</p>
                </div>
              </Alerts>
              {
                //     title === 'Regenesis Premium' && (
                //       <ContainerBtn>
                //         {/* <SmallBtn onClick={handleExternalClick} size="md">
                //   Onde comprar
                // </SmallBtn> */}
                //       </ContainerBtn>
                //     )
                //       || (
                //         <ContainerBtn>
                //           {/* <SmallBtn onClick={handleClick} size="md">
                //       Onde comprar
                //     </SmallBtn> */}
                //         </ContainerBtn>
                //       )
              }
            </div>
          </ContentWrapper>
        </SectionContainer>
      </div>
      {info.nutritional_information && (
        <SectionContainer>
          <ContainerImgInfo>
            <img
              src={info.nutritional_information}
              alt="Tabela de informações Nutricionais"
            />
          </ContainerImgInfo>
        </SectionContainer>
      )}
    </Container>
  );
};

export default Content;
